import globalEventBus from '@/services/globalEventBus';
import headerEvents from '@/domain/events/engineeringModulesHeader';

export default {
  methods: {
    updateHeaderTitle(subTitle) {
      globalEventBus.emit(headerEvents.updateTitle, subTitle);
    },
  },
};
